import { StoryCard, StoryCardContentGallery, StoryCardType } from '../../services';
import { GalleryItem } from '../models';

export const getStoryCardPreviewUrl = ({ type, content, event }: StoryCard): string => {
  if (type === StoryCardType.EVENT) {
    return event?.image?.url ?? '';
  }

  const { gallery } = content as StoryCardContentGallery;

  const galleryItem = gallery?.[0] as GalleryItem | undefined;

  const defaultUrl = galleryItem?.image?.url;

  switch (type) {
    case StoryCardType.IMAGE:
    case StoryCardType.QUOTE:
    case StoryCardType.POST:
    case StoryCardType.ARTICLE:
    case StoryCardType.PDF:
    case StoryCardType.POLL:
      return defaultUrl ?? '';
    case StoryCardType.AUDIO:
      return defaultUrl ?? galleryItem?.audio?.thumb ?? '';
    case StoryCardType.VIDEO:
      return defaultUrl ?? galleryItem?.video?.thumb ?? '';
    default:
      return '';
  }
};
